import NotificationStatus from "./NotificationStatus";
import NotificationStatusContainer from "./NotificationStatus.container";

export default NotificationStatusContainer;
export { NotificationStatus, NotificationStatusContainer };
